import React, { useState, useEffect, useCallback } from 'react';
import ReactConfetti from 'react-confetti';

interface UseConfettiOptions {
  /** Delay in ms before confetti starts (default: 500) */
  delay?: number;
  /** Whether confetti should trigger (default: true) */
  enabled?: boolean;
  /** Custom confetti colors (optional) */
  colors?: string[];
}

export const useConfetti = (options: UseConfettiOptions = {}) => {
  const { delay = 500, enabled = true, colors } = options;
  const [showConfetti, setShowConfetti] = useState(false);

  useEffect(() => {
    if (!enabled) {
      setShowConfetti(false);
      return;
    }
    const timer = setTimeout(() => setShowConfetti(true), delay);
    return () => clearTimeout(timer);
  }, [enabled, delay]);

  const handleComplete = useCallback(() => {
    setShowConfetti(false);
  }, []);

  const confetti = showConfetti ? (
    <div
      style={{
        width: '100%',
        position: 'absolute',
        top: 0,
        zIndex: 999,
      }}
    >
      <ReactConfetti
        run={showConfetti}
        width={window.innerWidth}
        height={window.innerHeight}
        numberOfPieces={200}
        gravity={0.25}
        recycle={false}
        onConfettiComplete={handleComplete}
        colors={colors}
      />
    </div>
  ) : null;

  return { confetti };
};
